import React from "react";
import type {
  DeleteStatus,
  DeletionType,
  SnapshotStatus,
} from "../../../services/tenantDeletionApi";

/**
 * Shared status badges for tenant deletion archive (list + details views).
 * Maps backend enum values to Polish user-facing labels.
 */

export const DeleteStatusBadge: React.FC<{ status: DeleteStatus }> = ({
  status,
}) => {
  const map: Record<DeleteStatus, { label: string; className: string }> = {
    PENDING_DELETE: {
      label: "W trakcie",
      className: "bg-yellow-100 text-yellow-800",
    },
    DELETED: {
      label: "Usunięty",
      className: "bg-green-100 text-green-800",
    },
    FAILED: {
      label: "Błąd",
      className: "bg-red-100 text-red-800",
    },
  };
  const cfg = map[status];
  return (
    <span
      className={`px-2 py-0.5 rounded-full text-xs font-medium ${cfg.className}`}
    >
      {cfg.label}
    </span>
  );
};

export const SnapshotBadge: React.FC<{ status: SnapshotStatus }> = ({
  status,
}) => {
  const className =
    status === "live"
      ? "bg-blue-100 text-blue-800"
      : "bg-neutral-100 text-neutral-600";
  return (
    <span
      className={`px-2 py-0.5 rounded-full text-xs font-medium ${className}`}
    >
      {status === "live" ? "Dostępny" : "Wyczyszczony"}
    </span>
  );
};

export const DeletionTypeBadge: React.FC<{ type: DeletionType }> = ({
  type,
}) => {
  const map: Record<DeletionType, { label: string; className: string }> = {
    manual_admin: {
      label: "Ręczne usunięcie (admin)",
      className: "bg-neutral-100 text-neutral-700",
    },
    gdpr_erasure: {
      label: "Usunięcie GDPR",
      className: "bg-purple-100 text-purple-800",
    },
    automatic_cleanup: {
      label: "Automatyczne czyszczenie",
      className: "bg-blue-100 text-blue-800",
    },
  };
  const cfg = map[type];
  return (
    <span
      className={`px-2 py-0.5 rounded-full text-xs font-medium ${cfg.className}`}
    >
      {cfg.label}
    </span>
  );
};
